import { motion } from "framer-motion";
import { FAQ } from "@/constants/testIds";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
    {
        q: "Why does your trial cost anything?",
        a: "Because from day one, our team is actively researching, building, and running your growth system. Not a demo. The real thing. The $49 covers the first week of live work on your account.",
    },
    {
        q: "Do you work internationally?",
        a: "Yes. We run growth systems for brands across the US, UK, India, and beyond, across every time zone.",
    },
    {
        q: "Is there a long-term contract?",
        a: "No. You continue with us because the results speak, not because a contract forces you to.",
    },
    {
        q: "How do you generate leads?",
        a: "Through strategic content, audience research, organic distribution, and conversion-focused profile positioning. The CASH framework in motion.",
    },
    {
        q: "What happens after the trial?",
        a: "If you like what you see, we move to a simple weekly partnership. If not, no hard feelings, no strings attached.",
    },
];

export default function Faq() {
    return (
        <section
            id="faq"
            data-testid={FAQ.root}
            className="relative py-24 md:py-32"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="text-center mb-12 md:mb-16"
                >
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        Frequently Asked
                    </p>
                    <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--text-primary)]">
                        Everything you need{" "}
                        <span className="italic text-[var(--accent-champagne)]">
                            to know.
                        </span>
                    </h2>
                </motion.div>

                <Accordion type="single" collapsible className="space-y-3">
                    {ITEMS.map((it, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={FAQ.item(i)}
                            data-glow-catch
                            className="rounded-2xl border border-[var(--border-subtle)] bg-[rgba(0,0,0,0.35)] px-5 md:px-6 data-[state=open]:border-[var(--border-accent)] transition-colors"
                        >
                            <AccordionTrigger className="text-left font-display text-lg md:text-2xl text-[var(--text-primary)] hover:no-underline py-5 md:py-6 [&[data-state=open]>svg]:text-[var(--accent-gold)]">
                                {it.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[var(--text-secondary)] text-base leading-relaxed pb-6 pr-4">
                                {it.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
